import React from 'react';
import './LegalPage.css';

const LegalPage = ({ page }) => (
  <main className="legal-page">
    <section className="legal-page__hero">
      <div className="container legal-page__hero-inner">
        <p className="legal-page__eyebrow">{page.eyebrow}</p>
        <h1 className="legal-page__title">{page.title}</h1>
        <p className="legal-page__subtitle">{page.subtitle}</p>
        <p className="legal-page__updated">Last updated: {page.lastUpdated}</p>
      </div>
    </section>

    <section className="legal-page__body">
      <div className="container legal-page__content">
        {page.sections.map((section) => (
          <article key={section.heading} className="legal-page__section">
            <h2 className="legal-page__section-title">{section.heading}</h2>
            {section.paragraphs.map((paragraph) => (
              <p key={paragraph} className="legal-page__copy">
                {paragraph}
              </p>
            ))}
          </article>
        ))}
      </div>
    </section>
  </main>
);

export default LegalPage;
